__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "agro-clima";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "17.0.7", () => (__webpack_require__.e(395).then(() => (() => (__webpack_require__(61395))))));
			register("@angular/common", "17.0.7", () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(26575))))));
			register("@angular/core", "17.0.7", () => (__webpack_require__.e(39).then(() => (() => (__webpack_require__(29039))))));
			register("@angular/forms", "17.0.7", () => (__webpack_require__.e(849).then(() => (() => (__webpack_require__(28849))))));
			register("@ngx-translate/core", "15.0.0", () => (__webpack_require__.e(393).then(() => (() => (__webpack_require__(96393))))));
			register("hslayers-ng", "11.0.0", () => (__webpack_require__.e(926).then(() => (() => (__webpack_require__(51285))))));
			register("ol/layer", "8.2.0", () => (__webpack_require__.e(208).then(() => (() => (__webpack_require__(57208))))));
			register("ol/source", "8.2.0", () => (__webpack_require__.e(676).then(() => (() => (__webpack_require__(27676))))));
			register("ol", "8.2.0", () => (__webpack_require__.e(931).then(() => (() => (__webpack_require__(41931))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};